import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppButton from '@/components/buttons/AppButton';
import FormField from '@/components/forms/FormField';
import CenterConatainer from '@/components/layouts/CenterContainer';
import LogoHeader from '@/components/layouts/LogoHeader';
import { validateLoggedInUser } from '@/services/user.service';
import { BUTTONS, HEADINGS, LABELS, PLACEHOLDERS } from '@/utils/constants/appConstants/commonConstants';
import { ERROR_CODES } from '@/utils/constants/constants';
import { PASSWORD_RESET_ERR_MSGS } from '@/utils/constants/messages';
import { getemail_address } from '@/utils/functions/TokenFunction';

const ValidateLoggedInUser = () => {
    const [password, setPassword] = useState("");
    const [msg, setMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [wrongPasswordCount, setWrongPasswordCount] = useState(0);
    const email = getemail_address();
    const navigate = useNavigate();

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => { setMsg(""); setPassword(e.target.value); };

    const handleSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);
        if (password.trim() === '') { setMsg(PASSWORD_RESET_ERR_MSGS.PASSWORD_REQUIRED); }
        if (wrongPasswordCount > 3) { setIsLoading(false); setMsg(PASSWORD_RESET_ERR_MSGS.PASSWORD_INCORRECT); return; }
        validateLoggedInUser({ email_address: email, password },
            (res: any) => { setIsLoading(false); navigate(`/my-profile`, { state: { canEdit: true, token: res.data } }); },
            (err: any) => {
                setIsLoading(false);
                setMsg(err?.response?.data?.message);
                if (err?.response?.data?.error_code === ERROR_CODES.WRONG_PASSWORD && err?.response?.status === ERROR_CODES.BAD_REQUEST) setWrongPasswordCount(wrongPasswordCount + 1);
            }
        );
    }, [email, password, setIsLoading]);

    return (
        <CenterConatainer>
            <LogoHeader id="login-form" heading={HEADINGS.LOGIN} children={undefined} />
            <form method="POST" id="signInForm" onSubmit={handleSubmit} autoComplete="off">
                <div className="mb-4">
                    <label className="text-sm font-medium text-foreground mb-1 block" htmlFor="login-form-password-input" id="login-form-password-label">{LABELS.PASSWORD}</label>
                    <FormField value={password} onChange={handlePasswordChange} type="password" id="login-form-password-input" placeholder={PLACEHOLDERS.PASSWORD} required />
                </div>
                {msg && <p className="text-destructive text-sm mb-3">{msg}</p>}
                <div>
                    <AppButton id="sign-in-btn" isLoading={isLoading} btnText={BUTTONS.SIGN_IN} className="btn-lg btn-block btn-primary" type="submit" />
                </div>
            </form>
        </CenterConatainer>
    );
};

export default ValidateLoggedInUser;
